<template>
  <el-input
    v-model="phone_input"
    v-mask="mask"
    :placeholder="placeholder"
    :maxlength="10"
    :readonly="readOnly"
    show-word-limit
  >
    <template slot="prepend"> +7 </template>
  </el-input>
</template>

<script>
import AwesomeMask from "awesome-mask";
export default {
  directives: {
    mask: AwesomeMask,
  },
  props: {
    maxLength: {
      type: Number,
      required: false,
      default: 10,
    },
    value: {
      type: [String],
      required: false,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mask: "9999999999",
      placeholder: "10 цифр номера телефона (Без +7)",
      phone_input: "",
    };
  },
  computed: {
    phone: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val || undefined);
      },
    },
  },
  watch: {
    phone_input() {
      if (this.phone_input) {
        this.phone = `+7${this.phone_input}`;
      }
    },
  },
};
</script>
